"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFeedback = void 0;
const common_1 = require("@bugfender/common");
const utils_1 = require("./utils");
const issue_1 = require("./types/issue");
const user_feedback_scss_1 = __importDefault(require("./templates/user-feedback.scss"));
const user_feedback_html_1 = __importDefault(require("./templates/user-feedback.html"));
class UserFeedbackModal {
    constructor(options, onClose, onSubmit) {
        this.options = options;
        this.onClose = onClose;
        this.onSubmit = onSubmit;
        this.wrapperEl = document.createElement('div');
        this.shadow = this.wrapperEl.attachShadow({ mode: 'closed' });
        this.shadow.innerHTML = user_feedback_html_1.default;
        this.titleEl = this.querySelector('[data-bf-title]');
        this.titleEl.innerText = this.options.title;
        this.hintEl = this.querySelector('[data-bf-hint]');
        if (this.options.hint) {
            this.hintEl.innerText = this.options.hint;
            this.hintEl.classList.remove('bf-modal__hint--hidden');
        }
        this.subjectEl = this.querySelector('[data-bf-subject]');
        this.subjectEl.setAttribute('placeholder', this.options.subjectPlaceholder);
        this.feedbackEl = this.querySelector('[data-bf-feedback]');
        this.feedbackEl.setAttribute('placeholder', this.options.feedbackPlaceholder);
        this.submitEl = this.querySelector('[data-bf-submit]');
        this.submitEl.innerText = this.options.submitLabel;
        this.backdropEl = this.querySelector('[data-bf-backdrop]');
        this.backdropEl.addEventListener('click', this.onClose);
        this.closeEl = this.querySelector('[data-bf-close]');
        this.closeEl.addEventListener('click', this.onClose);
        this.formEl = this.querySelector('[data-bf-form]');
        this.submitCb = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onSubmit(this.subjectEl.value, this.feedbackEl.value);
        };
        this.formEl.addEventListener('submit', this.submitCb);
        const body = document.querySelector('body');
        if (body) {
            body.appendChild(this.wrapperEl);
        }
        const style = document.createElement('style');
        style.textContent = user_feedback_scss_1.default.toString();
        this.shadow.append(style);
    }
    querySelector(selectors) {
        const el = this.shadow.querySelector(selectors);
        if (el) {
            return el;
        }
        else {
            throw new Error(`Element for selector "${selectors}" not found.`);
        }
    }
    drop() {
        this.backdropEl.removeEventListener('click', this.onClose);
        this.closeEl.removeEventListener('click', this.onClose);
        this.formEl.removeEventListener('submit', this.submitCb);
        this.backdropEl.remove();
        this.closeEl.remove();
        this.feedbackEl.remove();
        this.formEl.remove();
        this.subjectEl.remove();
        this.submitEl.remove();
        this.titleEl.remove();
        this.shadow.innerHTML = '';
        this.wrapperEl.innerHTML = '';
        this.wrapperEl.remove();
    }
}
class UserFeedback {
    constructor(commands) {
        this.commands = commands;
        this.optionsValidator = new common_1.UserFeedbackOptionsValidator();
    }
    cancel() {
        this.resolve({ isSent: false });
        this.drop();
    }
    drop() {
        var _a;
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.drop();
        this.modal = undefined;
    }
    resolve(result) {
        var _a;
        (_a = this.deferred) === null || _a === void 0 ? void 0 : _a.resolve(result);
        this.deferred = undefined;
    }
    show(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deferred) {
                return this.deferred.promise;
            }
            this.deferred = (0, utils_1.createDeferred)();
            this.modal = new UserFeedbackModal(this.optionsValidator.init(options), () => this.cancel(), (subject, feedback) => this.submit(subject, feedback));
            return this.deferred.promise;
        });
    }
    submit(subject, feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const feedbackURL = yield this.commands.addIssue(issue_1.IssueType.Feedback, subject, feedback);
                this.resolve({ isSent: true, feedbackURL });
            }
            catch (_a) {
                this.resolve({ isSent: false });
            }
            this.drop();
        });
    }
}
exports.UserFeedback = UserFeedback;
